import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

// Shared pieces of the profile statistics columns.

export function InfoIcon({ text }) {
  return (
    <Tooltip title={text}>
      <QuestionCircleOutlined className="ml-1.5 align-middle text-sm font-normal text-zinc-400" />
    </Tooltip>
  );
}

export function ChartCard({ title, sub, info, children }) {
  return (
    <div className="flex flex-col gap-2.5 rounded-[14px] border border-zinc-200 bg-white px-4 py-3.5">
      <div>
        <h2 className="m-0 text-[15px] font-extrabold">
          {title}
          {info && <InfoIcon text={info} />}
        </h2>
        {sub && <div className="text-xs text-zinc-500">{sub}</div>}
      </div>
      {children}
    </div>
  );
}

export function HBars({ rows }) {
  const max = Math.max(1, ...rows.map((r) => r.value));
  return (
    <div className="grid gap-1">
      {rows.map((r) => (
        <div
          key={r.label}
          className="grid grid-cols-[140px_minmax(0,1fr)_56px] items-center gap-2.5 text-[13px]"
        >
          <span className="truncate">{r.label}</span>
          <div className="h-3.5 overflow-hidden rounded-r bg-zinc-100">
            <div
              className="h-full rounded-r"
              style={{
                width: `${(r.value / max) * 100}%`,
                backgroundColor: r.color || 'rgb(var(--accentColor))',
              }}
            />
          </div>
          <strong className="text-right">{r.text ?? r.value}</strong>
        </div>
      ))}
    </div>
  );
}
